// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IscH9HXUlKY_T1ohfXO7{cursor:pointer;border-radius:4px;width:100%;height:auto;margin:0 auto}.gKDd0q1bTiM_hJ44XHND{max-width:312px}.KOhgJD9oLI9HASw7lwWQ{background:var(--background-primary-inverted-primary);border-radius:4px;align-items:center;gap:8px;width:100%;max-width:344px;padding:8.5px 8px;display:flex}.YlD1v9N818UXLiMMSJE3{background-color:var(--background-neutral-primary);border-radius:50%;flex:0 0 32px;justify-content:center;align-items:center;width:32px;height:32px;display:flex}.CvObDiKBWcmyZ5zcSq3U{color:var(--content-primary-primary)}.YJ71DAFI1VctDTSWbgZL{color:var(--content-primary-tertiary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"img": `IscH9HXUlKY_T1ohfXO7`,
	"withPreviews": `gKDd0q1bTiM_hJ44XHND`,
	"card": `KOhgJD9oLI9HASw7lwWQ`,
	"card__avatar": `YlD1v9N818UXLiMMSJE3`,
	"cardAvatar": `YlD1v9N818UXLiMMSJE3`,
	"card__title": `CvObDiKBWcmyZ5zcSq3U`,
	"cardTitle": `CvObDiKBWcmyZ5zcSq3U`,
	"card__desc": `YJ71DAFI1VctDTSWbgZL`,
	"cardDesc": `YJ71DAFI1VctDTSWbgZL`
};
export default ___CSS_LOADER_EXPORT___;
